import { render } from "./WishlistAddToMembership.vue?vue&type=template&id=ac1f739a"
import script from "./WishlistAddToMembership.vue?vue&type=script&lang=js"
export * from "./WishlistAddToMembership.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__